export const OperationRecordsApi = Symbol('OperationRecordsApi');
